import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'wdx-checkbox-tile-group',
    templateUrl: './wdx-checkbox-tile-group.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'input-check-tiles',
    },
    standalone: false,
})
export class WdxCheckboxTileGroupComponent {}
